import * as React from "react";

function SvgCatalogSmall(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
      <defs>
        <clipPath id="CatalogSmall_svg__a">
          <path
            data-name="Rectangle 4244"
            transform="translate(281 410)"
            fill="#fff"
            stroke="#707070"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
      <g
        data-name="Mask Group 5"
        transform="translate(-281 -410)"
        clipPath="url(#CatalogSmall_svg__a)"
      >
        <g data-name="Group 11067">
          <g data-name="Group 11063">
            <g data-name="Group 11062" fill="#039be5">
              <path
                data-name="Path 43340"
                d="M289.138 438.247q0-2.97-.006-5.941v-.308h-1.8c.047-.1.075-.175.109-.243.581-1.162 1.166-2.322 1.74-3.486a.3.3 0 01.32-.2q7.456.008 14.912 0c.119 0 .219-.006.288.136.606 1.228 1.22 2.452 1.832 3.677.013.026.02.056.038.107h-1.8v6.257zm7.054-.813h7.778v-5.441h-.3c-2.106 0-4.213 0-6.319.005a.348.348 0 01-.371-.235c-.212-.456-.447-.9-.674-1.352-.025-.049-.06-.094-.113-.178zm-.823.007v-7.264c-.291.581-.559 1.1-.809 1.624a.3.3 0 01-.323.2c-1.35-.007-2.7 0-4.049 0h-.255v5.448zm9.936-6.244c-.366-.731-.715-1.418-1.05-2.112a.333.333 0 00-.353-.224c-2.406.008-4.812.005-7.218.005h-.255c.046.1.076.171.11.24.313.626.634 1.25.935 1.882a.335.335 0 00.361.214q3.6-.009 7.194 0zm-10.175-2.311a1.015 1.015 0 00-.109-.017c-1.7 0-3.409 0-5.113.005a.311.311 0 00-.217.154c-.308.595-.6 1.2-.9 1.795l-.187.375h5.247a.223.223 0 00.166-.092c.37-.732.734-1.463 1.113-2.22z"
              />
              <path
                data-name="Path 43341"
                d="M295.536 416.045c.4-.364.759-.751 1.174-1.07a5.074 5.074 0 015.809-.119 4.976 4.976 0 012.174 3.355c.064.377.174.511.552.6a3.509 3.509 0 01-.247 6.861 12.714 12.714 0 01-1.747.068c-.266.007-.532 0-.812 0v-.8h1.969a2.632 2.632 0 001.163-.271 2.727 2.727 0 00-1.137-5.184h-.44a4.35 4.35 0 00-1.856-3.929 4.213 4.213 0 00-2.535-.765 4.31 4.31 0 00-4.159 3.571l-.808-.129c.145-.427.272-.83.421-1.224a.289.289 0 00-.047-.356 3.056 3.056 0 00-3.283-.942 3.088 3.088 0 00-2.169 2.611c-.012.11-.022.219-.031.316l1.336.273-.308.761a2.937 2.937 0 00-1.564-.139 2.726 2.726 0 00.06 5.36 7.094 7.094 0 00.942.047c.488.007.975 0 1.478 0v.8c-.307 0-.6.01-.9 0a11.982 11.982 0 01-1.813-.1 3.5 3.5 0 01-.212-6.794c.243-.067.2-.225.208-.375a3.805 3.805 0 012.227-3.3 3.863 3.863 0 014.43.763l.125.111z"
              />
              <path
                data-name="Path 43342"
                d="M293.429 426.109h-.761a4.29 4.29 0 018.579 0h-.77a3.515 3.515 0 00-1.572-2.9 3.357 3.357 0 00-2.289-.58 3.538 3.538 0 00-3.187 3.48z"
              />
              <path
                data-name="Path 43343"
                d="M294.992 426.115h-.78a2.654 2.654 0 011.055-2.142 2.6 2.6 0 012.928-.284 2.7 2.7 0 011.508 2.415h-.78c-.247-1.276-.962-1.956-2.023-1.926a1.973 1.973 0 00-1.908 1.937z"
              />
              <path
                data-name="Path 43344"
                d="M303.188 419.073h-.761a2.735 2.735 0 00-.8-1.918 2.7 2.7 0 00-1.908-.8v-.764a3.454 3.454 0 013.469 3.482z"
              />
              <path
                data-name="Path 43345"
                d="M298.131 426.122a1.178 1.178 0 11-1.18-1.177 1.2 1.2 0 011.18 1.177zm-1.171-.379a.381.381 0 10.373.4.384.384 0 00-.373-.4z"
              />
              <path
                data-name="Path 43346"
                d="M289.507 420.268v.7a5.816 5.816 0 00-.738.365.921.921 0 00-.39.7c-.014.14-.064.193-.205.186-.188-.009-.376 0-.56 0a1.868 1.868 0 011.893-1.951z"
              />
              <path
                data-name="Path 43352"
                d="M303.197 434.339v.769h-4.668v-.769z"
              />
              <path
                data-name="Path 43353"
                d="M301.635 435.908v.758h-3.1v-.758z"
              />
              <path
                data-name="Path 43354"
                d="M303.196 435.903v.768h-.753v-.768z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgCatalogSmall;
